import { features as initialFeatures } from "./registry";

export const features: Partial<{
  [K in keyof typeof initialFeatures]: typeof initialFeatures[K];
}> = {};
